/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Field, Formik } from 'formik';
import InputField from 'components/Form/InputField';
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import Label from 'components/Form/Label';
import FileModal from 'components/FileModal';
import DialogComponent from 'components/Dialog';
import { TextEditorBox } from 'components/index';

import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { ButtonContent, ContentTextarea, DialogConfirm, DialogRejected, Scrollbox, TextArea, Textarea } from './styles';
import Access from 'constants/Access';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import { useHeaderNbi, useFileNbiEmailUpdated, useAproveNbiReq } from 'services/QuoteService'; 
import { useOperationInfo } from 'services/OperationService';
import { useAccess } from "services/AccessService";

export default function NbiAproval(props) {
  const formikRef = useRef(null);
  const loading = useContext(GlobalLoaderContext);
  const [summary, setSummary] = useState({})
  const [file, setFile] = useState();
  const [isClient, setIsClient] = useState(false);
  const history = useHistory();
  const [historymsg, setHistorymsg] = useState([]);
  const [nbiMessage, setNbiMessage] = useState("");
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const [idProductOperation, setIdProductOperation] = useState(12);
  const [hasDirectorPermission, setHasDirectorPermission] = useState(false);
  const [isBound, setIsBound] = useState('');
  const [initial, setInitial] = useState({
    subject: "",
  });

  const goToLoginPage = () => {
    history.push('/login');
  };

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useFileNbiEmailUpdatedData,
    loading: useFileNbiEmailUpdatedLoading,
    error: useFileNbiEmailUpdatedError,
    status: useFileNbiEmailUpdatedStatus,
    request: useFileNbiEmailUpdatedRequest,
  } = useFileNbiEmailUpdated();

  const {
    data: useAccessData,
    loading: useAccessLoading,
    error: useAccessError,
    status: useAccessStatus,
    request: useAccessRequest,
  } = useAccess(true);

  const {
    data: useAproveNbiReqData,
    loading: useAproveNbiReqLoading,
    error: useAproveNbiReqError,
    status: useAproveNbiReqStatus,
    request: useAproveNbiReqRequest,
  } = useAproveNbiReq();

  useEffect(() => {
    if (useHeaderNbiLoading || useOperationInfoLoading || useFileNbiEmailUpdatedLoading || useAccessLoading || useAproveNbiReqLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useOperationInfoLoading, useFileNbiEmailUpdatedLoading, useAccessLoading, useAproveNbiReqLoading]);

  async function directorPermission() {
    const {data: response} = await useAccessRequest({username: "", dsDomPrivilege: "READ", idDomain: Access.BROKER_SENIOR_APPROVAL, idPersonRelation: null, 
    idOperation: props.match?.params?.idOperation, token: authContext.token }, null);

    //const hasPermission = response && response.ret_code === 200;
    const hasPermission = response && response.ret_code === 200 && response.ret_value.isSameLeadingOffice === true;
    setHasDirectorPermission(hasPermission);
  }

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${new Date(message.approvalDate).toString()}
            ${message.approvalComments}
      
              `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }
  };

  function handleFileNbiRequestEmailUpdated() {
    useFileNbiEmailUpdatedRequest({idOperation: props.match.params.idOperation, idTemplate: 186}, null).then(({data}) => {
        setFile(data);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFileNbiRequestEmailUpdated.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });
  };
  
  function handleFile() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestDocument(props.match.params.idOperation)
      .then(a => {
        if (a.status !== 200) {
          a.json().then(res => {
            mc.error(res.ret_msg_details);
            history.goBack();
            return;
          })
        } else {
          // a.text().then((response) => {
          //   setFile(JSON.parse(response));
          // })
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          operationStatus: data.ret_value.idOperation,
          idOperation: props.match.params.idOperation,
        });
        setNbiMessage(data.ret_value.nbiSubjectMessage);
        setHistorymsg(data.ret_value.historical);
        setIdProductOperation(data.ret_value.idProduct);
        console.log("data.ret_value.endorsmentType", data.ret_value.idProduct)
        formikRef.current?.setFieldValue("subject", data.ret_value.nbiSubject);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  async function handleAproval() {
    useAproveNbiReqRequest({idOperation: props.match.params.idOperation, txtAnswerOption: userComments}, null).then(({data: resp}) => {
        if (resp.ret_code === 200) {
          if (idProductOperation !== 16) {
            history.push(`/broking/select-markets/${props.match.params.idOperation}`, { idProduct: props.location.state.idProduct });
          } else {
            history.push(`/broking/select-markets/${props.match.params.idOperation}/16`, { idProduct: props.location.state.idProduct });
          }
        } else {
          mc.error(resp.ret_msg_details);
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleAproval.name}\n` + error);
        console.error('fitPostAproval - Error:', error);
      });

  };

  async function handleReject() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestRejectNbiReq(props.match.params.idOperation, userComments).then(x => x.json()).then(resp => {
      if (resp.ret_code === 200) {
        mc.success("NBI Request Rejected");
        props.history.push('/list');
      } else {
        mc.error(resp.ret_msg_details);

      }
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleReject.name}\n` + error);
      console.error('fitPostReject - Error:', error);
    });
  };

  const [userComments, setUserComments] = useState(null);
  const [typeDialog, setTypeDialog] = useState(null);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });


  function handleBack() {
    history.goBack();
  }


  function handleCancel() {
    setUserComments("");
    setDialog({
      visible: false,
      title: '',
      icon: 'exclamation',
      args: null
    })
  }

  function handleDialog(type) {
    if (type === "Approve") {
      setTypeDialog("Approve");
      setDialog({
        visible: true,
        title: "APPROVE NBI Request",
        icon: "TimesCircle",
        args: null,
      })
    } else {
      setTypeDialog("Reject");
      setDialog({
        visible: true,
        title: "REJECT NBI Request",
        icon: "TimesCircle",
        args: null,
      })
    }
  };

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    if (authContext.enumProfile === 1) {
      setIsClient(true);
    } else {
      setIsClient(false)
    };

    handleSummary();
    directorPermission();
    handleOperationInfo(); 
    handleFileNbiRequestEmailUpdated();
  }, []);

  const handleOperationInfo = () => {
    useOperationInfoRequest().then(({data}) => {
      setIsBound(data.isBound || false)
      })
  }

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary?.nmObligor ? summary?.nmObligor : "Broking name"} subtitle={summary?.dealCode ? summary?.dealCode : "Deal Code"}>
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <Scrollbox>
        <BrokingSummary data={summary} />

        <ContentCard title={isClient ? "APPROVAL NBI" : "APPROVAL NBI REQUEST"} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
          <DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
            {typeDialog === 'Approve' ?
              <ContentTextarea>
                <p>Deal Analysis information</p>
                <Textarea value={userComments} onChange={(e) => setUserComments(e.target.value)}></Textarea>
                <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
                <DialogConfirm onClick={() => handleAproval()}>CONFIRM</DialogConfirm>
              </ContentTextarea>

              : typeDialog === 'Reject' ?
                <ContentTextarea>
                  <p>Deal Analysis information</p>
                  <Textarea value={userComments} onChange={(e) => setUserComments(e.target.value)}></Textarea>
                  <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
                  <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
                </ContentTextarea>
                : ''
            }
          </DialogComponent>

          <Formik
            innerRef={formikRef}
            initialValues={initial}
            enableReinitialize={true}
          >
            {({ values }) => (
              <Field
                name="subject"
                label="NBI Request e-mail Subject Line"
                component={InputField}
                value={values.subject}
                disabled
              />
            )}
          </Formik>

          <FileModal idOperation={props?.match?.params?.idOperation} file={file} actions={false}/>

          {isClient ? "" : <>
            <Label>Deal Analysis Information</Label>
            <TextArea
              readOnly
              value={handleHistoryMessage()}
            />
          </>
          }

          {(hasDirectorPermission) &&
            <ButtonContainer>
              <Button forth onClick={() => handleBack()}>&lt; Back</Button>
              <HasPermission permission={!isBound}>
              <RenderButtons idOperation={props.match?.params?.idOperation}>
                <ButtonContent>
                  <Button secundary onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Reject") }} style={{ marginLeft: "10px", marginTop: "5px" }}>
                    REJECT
                  </Button>
                  <Button primary onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Approve") }} style={{ marginLeft: "10px", marginTop: "5px" }}>
                    APPROVE
                  </Button>
                </ButtonContent>
              </RenderButtons>
              </HasPermission>
            </ButtonContainer>
          }
        </ContentCard>
      </Scrollbox>
    </Layout >
  )
}
